import {
  FpjsProvider,
  FingerprintJSPro,
} from '@fingerprintjs/fingerprintjs-pro-react';
import { ReactNode } from 'react';

interface FingerprintProviderrProps {
  children: ReactNode;
}

const FingerprintProvider = ({ children } : FingerprintProviderrProps) => {
  const FINGERPRINT_SECRET = import.meta.env.VITE_FINGERPRINT_KEY;
  const FINGERPRINT_ENDPOINT = import.meta.env.VITE_FINGERPRINT_ENDPOINT;
  const FINGERPRINT_SCRIPT = import.meta.env.VITE_FINGERPRINT_SCRIPT;
  const isFingerprintEnabled = import.meta.env.VITE_FINGERPRINT_ENABLED === 'true';
  const FINGERPRINT_REGION = 'eu';

  return (
    isFingerprintEnabled 
      ? <FpjsProvider
          loadOptions={{
            apiKey: FINGERPRINT_SECRET,
            region: FINGERPRINT_REGION,
            endpoint: [
              FINGERPRINT_ENDPOINT,
              FingerprintJSPro.defaultEndpoint,
            ],
            scriptUrlPattern: [
              FINGERPRINT_SCRIPT,
              FingerprintJSPro.defaultScriptUrlPattern,
            ],
          }}
        >
          {children}
        </FpjsProvider>
      : <>{children}</>
  );
};

export default FingerprintProvider;
